import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { Header } from "@/components/Header";
import { ProductGrid } from "@/components/ProductGrid";
import { Navigation } from "./home/components/Navigation";
import { HeroSection } from "./home/components/HeroSection";
import { FeatureSection } from "./home/components/FeatureSection";
import { Footer } from "./home/components/Footer";
interface Product {
  id: string;
  name: string;
  description: string;
  link: string;
  logo: string;
  product_screen: string;
  features?: string;
  visible?: boolean;
}
const Index = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const {
    toast
  } = useToast();
  useEffect(() => {
    checkAdminStatus();
    fetchProducts();
  }, []);
  const checkAdminStatus = async () => {
    try {
      const {
        data: session
      } = await supabase.auth.getSession();
      if (!session.session) {
        return;
      }
      const {
        data: adminData,
        error
      } = await supabase.from('admin_users').select('*').eq('user_id', session.session.user.id).maybeSingle();
      if (error) {
        console.error('Error checking admin status:', error);
        return;
      }
      setIsAdmin(!!adminData);
    } catch (error) {
      console.error('Error checking admin status:', error);
    }
  };
  const fetchProducts = async () => {
    try {
      // Only fetch visible products for regular users
      // For admins, we'll filter on the client side
      const {
        data,
        error
      } = await supabase.from('products').select('*');
      if (error) {
        throw error;
      }
      if (data) {
        const formattedProducts = data.map(product => ({
          id: product.id,
          name: product.name,
          description: product.description || "",
          link: product.link || "",
          logo: product.logo || "",
          product_screen: product.product_screen || "",
          features: product.features || "",
          visible: product.visible
        }));
        setProducts(formattedProducts);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching products:', error);
      toast({
        title: "Error",
        description: "Failed to load products.",
        variant: "destructive"
      });
      setIsLoading(false);
    }
  };
  if (isLoading) {
    return <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <p className="text-lg">Loading products...</p>
      </div>;
  }

  // Filter products for display on home page (only show visible products)
  const visibleProducts = products.filter(product => product.visible !== false);
  return <div className="min-h-screen bg-gray-100">
      <Navigation isAdmin={isAdmin} />
      <HeroSection />
      <FeatureSection />
      <div id="products-section" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-[32px] pb-[60px] pt-[85px] ">
        <ProductGrid products={visibleProducts} isAdmin={isAdmin} />
      </div>
      <Footer />
    </div>;
};
export default Index;
